// import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import { useAuth } from "AuthContext";
// import { useMemo } from "react";

// //import { Card, Checkbox, FormControlLabel } from "@mui/material";
// import {
//   Card,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
// } from "@mui/material";

// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftInput from "components/SoftInput";
// import SoftButton from "components/SoftButton";
// import FormField from "layouts/pages/account/components/FormField";
// import SoftSnackbar from "components/SoftSnackbar";
// import { changeUserStatus } from "api/users";

// function JobRelatedDataForm({ value = {}, onChange, onUpdate, loading, setLoading }) {

//   /* ================= PERMISSIONS ================= */
//   const { permissions: ctxPerms = [] } = useAuth();

//   const storedPerms = useMemo(() => {
//     try {
//       return JSON.parse(localStorage.getItem("permissions") || "[]");
//     } catch {
//       return [];
//     }
//   }, []);

//   const permSet = useMemo(() => {
//     const perms = ctxPerms.length ? ctxPerms : storedPerms;
//     return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
//   }, [ctxPerms, storedPerms]);

//   const canSection = permSet.has("UserProfile.JobRelatedData");
//   const canView = (key) => permSet.has(`UserProfile.JobRelatedData.${key}`);

//   const [formData, setFormData] = useState({ ...value });
//   const [saveLoading, setSaveLoading] = useState(false);
//   const [rejectLoading, setRejectLoading] = useState(false);
//   const [shortlistLoading, setShortlistLoading] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     color: "success",
//   });

//   useEffect(() => {
//     setFormData({ ...value });
//   }, [value]);

//   const handleRadioChange = (fieldName) => (event) => {
//     const value = event.target.value;

//     const updatedData = {
//       ...formData,
//       [fieldName]: value ? [value] : [],
//     };

//     setFormData(updatedData);
//     onChange?.(updatedData);
//   };

//   const handleTextChange = (field) => (event) => {
//     const updatedData = { ...formData, [field]: event.target.value };
//     setFormData(updatedData);
//     onChange?.(updatedData);
//   };

//   const renderOptions = (title, fieldName, options) => (

//     <SoftBox mb={3}>
//       <SoftTypography variant="caption" fontWeight="bold" className="mb-2">
//         {title}
//       </SoftTypography>

//       <RadioGroup
//         row
//         value={(formData[fieldName] ?? [])[0] || ""}
//         onChange={handleRadioChange(fieldName)}
//       >
//         <div className="row">
//           {options.map((opt) => (
//             <div className="col-md-3 col-6" key={opt}>
//               <FormControlLabel
//                 value={opt}
//                 control={<Radio />}
//                 label={opt}
//               />
//             </div>
//           ))}
//         </div>
//       </RadioGroup>
//     </SoftBox>

//   );
//   const handleStatusUpdate = async (status) => {
//     if (!value.id) {
//       console.error("User ID is missing.");
//       setSnackbar({
//         open: true,
//         message: "User ID is missing.",
//         color: "error",
//       });
//       return;
//     }

//     // Set specific loading
//     if (status === "reject") setRejectLoading(true);
//     if (status === "shortlist") setShortlistLoading(true);

//     try {
//       const response = await changeUserStatus(value.id, status);

//       setSnackbar({
//         open: true,
//         message:
//           response.data?.message ||
//           `${status === "reject" ? "Rejected" : "Shortlisted"} successfully!`,
//         color: "success",
//       });
//     } catch (error) {
//       console.error(`Failed to ${status} candidate:`, error);
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || `Failed to ${status} candidate.`,
//         color: "error",
//       });
//     } finally {
//       if (status === "reject") setRejectLoading(false);
//       if (status === "shortlist") setShortlistLoading(false);
//     }
//   };

//   if (!canSection) {
//     return null;
//   }

//   return (
//     <Card className="p-4" >
//       <SoftBox mb={3}>
//         <SoftTypography variant="h5" className="mb-3">
//           Job Related Data
//         </SoftTypography>

//         {/* Job Responsibilities */}
//         <div className="container" >
//           {canView("JobResponsibility") && (
//             <>
//               {renderOptions("1. Present Job Responsibility", "job_responsibility", [
//                 "Fully Relevant",
//                 "Partially Relevant",
//                 "Allied Area",
//                 "Not Relevant",
//               ])}
//             </>
//           )}
//           {canView("JobKnowledge") && (
//             <>
//               {renderOptions("2. Job Knowledge", "job_knowledge", [
//                 "Very Good",
//                 "Good",
//                 "Just Sufficient",
//                 "Not Sufficient",
//               ])}
//             </>
//           )}
//           {canView("JobExpertise") && (
//             <>

//               {renderOptions("3. Job Expertise", "job_expertise", [
//                 "Very Good",
//                 "Good",
//                 "Above Average",
//                 "Acceptable",
//                 "Below Average",
//               ])}
//             </>
//           )}
//           {canView("ApproachToProblem") && (
//             <>
//               {renderOptions("4. Approach to Problem", "approach_to_problem", [
//                 "Logical",
//                 "Balanced",
//                 "Confused",
//               ])}
//             </>
//           )}

//           {/* Text Fields */}
//           {canView("JobAchievements") && (
//             <div className="row mb-4">
//               <div className="col-12">
//                 <SoftTypography variant="caption" fontWeight="bold">
//                   5. Job Related Achievements
//                 </SoftTypography>
//                 <SoftInput
//                   placeholder="Your achievements"
//                   value={formData.job_achievements || ""}
//                   onChange={handleTextChange("job_achievements")}
//                 />
//               </div>
//             </div>
//           )}

//           {canView("ReasonForReaving") && (
//             <div className="row mb-4">
//               <div className="col-12">
//                 <SoftTypography variant="caption" fontWeight="bold">
//                   6. Reason for leaving present job
//                 </SoftTypography>
//                 <SoftInput
//                   placeholder="Write your reason"
//                   value={formData.reason_for_leaving || ""}
//                   onChange={handleTextChange("reason_for_leaving")}
//                 />
//               </div>
//             </div>
//           )}
//           {canView("PersonalStrength") && (
//             <>
//               <SoftTypography variant="caption" fontWeight="bold" className="mt-4 mb-2">
//                 Personal Traits
//               </SoftTypography>

//               {renderOptions("1. Personality", "personality", [
//                 "Impressive",
//                 "Smart",
//                 "Good",
//                 "Average",
//                 "Not Good",
//               ])}
//               {renderOptions("2. Leadership", "leadership", [
//                 "Very Good",
//                 "Good",
//                 "Average",
//                 "Poor",
//                 "Not Good",
//               ])}
//               {renderOptions("3. Initiative", "initiative", [
//                 "Self Motivated",
//                 "Needs Prompting",
//                 "Lacks Initiative",
//                 "Impulsive",
//               ])}
//               {renderOptions("4. Mannerism", "mannerism", [
//                 "Pleasant",
//                 "Acceptable",
//                 "Do not know etiquette",
//               ])}

//             </>
//           )}

//           {/* Strength & Weakness */}
//           {canView("PersonalWeakness") && (
//             <div className="row mb-4">
//               <div className="col-12 col-md-6">
//                 <SoftTypography variant="caption" fontWeight="bold">
//                   His/Her Strength
//                 </SoftTypography>
//                 <SoftInput
//                   placeholder="Write your Strength"
//                   value={formData.strength || ""}
//                   onChange={handleTextChange("strength")}
//                 />
//               </div>
//               <div className="col-12 col-md-6">
//                 <SoftTypography variant="caption" fontWeight="bold">
//                   His/Her Weakness
//                 </SoftTypography>
//                 <SoftInput
//                   placeholder="Write your Weakness"
//                   value={formData.weakness || ""}
//                   onChange={handleTextChange("weakness")}
//                 />
//               </div>
//             </div>
//           )}

//           {/* Other Fields */}

//           <div className="row mb-4">
//             {canView("Remarks") && (
//               <div className="col-md-4 mb-3">
//                 <FormField
//                   label="Remarks"
//                   placeholder="Write your Remarks"
//                   value={formData.remarks || ""}
//                   onChange={handleTextChange("remarks")}
//                 />
//               </div>
//             )}
//             {canView("InterviewBy") && (
//               <div className="col-md-4 mb-3">
//                 <FormField
//                   label="Interviewed By"
//                   placeholder="Interviewer Name"
//                   value={formData.interview_by || ""}
//                   onChange={handleTextChange("interview_by")}
//                 />
//               </div>
//             )}
//             {canView("InterviewDate") && (
//               <div className="col-md-4 mb-3">
//                 <FormField
//                   label="Interview Date"
//                   type="date"
//                   placeholder="Interview Date"
//                   value={formData.interview_date || ""}
//                   onChange={handleTextChange("interview_date")}
//                 />
//               </div>
//             )}
//             {canView("JoiningDate") && (
//               <div className="col-md-4 mb-3">
//                 <FormField
//                   label="Joining Date"
//                   type="date"
//                   placeholder="Joining Date"
//                   value={formData.joining_date || ""}
//                   onChange={handleTextChange("joining_date")}
//                 />
//               </div>
//             )}
//           </div>

//           {/* Buttons */}
//           <div className="d-flex justify-content-end gap-3">
//             {canView("ShortListed") && (
//               <SoftButton
//                 disable={saveLoading || !value.is_jobrelateddata}
//                 variant="gradient"
//                 color="info"
//                 onClick={async () => {
//                   setSaveLoading(true);
//                   await onUpdate();
//                   setSaveLoading(false);
//                 }}
//               >
//                 {saveLoading ? "Shortlisting" : value.status == "shortlisted" ? "Shortlisted" : "Shortlist"}
//               </SoftButton>
//             )}
//             {canView("Reject") && (
//               <SoftButton
//                 variant="gradient"
//                 color="error"
//                 onClick={() => handleStatusUpdate("reject")}
//                 disabled={rejectLoading}
//               >
//                 {rejectLoading ? "Rejecting..." : "Reject"}
//               </SoftButton>
//             )}
//           </div>
//         </div>

//         <SoftSnackbar
//           color={snackbar.color}
//           icon="notifications"
//           title="Notification"
//           content={snackbar.message}
//           open={snackbar.open}
//           close={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           time={3000}
//         />
//       </SoftBox>
//     </Card>
//   );
// }

// JobRelatedDataForm.propTypes = {
//   value: PropTypes.object,
//   onChange: PropTypes.func,
//   onUpdate: PropTypes.func,
//   loading: PropTypes.bool,
//   setLoading: PropTypes.func,
// };

// export default JobRelatedDataForm;

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useAuth } from "AuthContext";
import { useMemo } from "react";

import {
  Card,
  Radio,
  RadioGroup,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import FormField from "layouts/pages/account/components/FormField";
import SoftSnackbar from "components/SoftSnackbar";
import { changeUserStatus } from "api/users";

function JobRelatedDataForm({ value = {}, onChange, onUpdate, loading, setLoading }) {
  /* ================= PERMISSIONS ================= */
  const { permissions: ctxPerms = [] } = useAuth();
  const [requiredErrors, setRequiredErrors] = useState([]);
  const REQUIRED_FIELDS = [
    { perm: "JobResponsibility", field: "job_responsibility", label: "Present Job Responsibility", type: "radio" },
    { perm: "JobKnowledge", field: "job_knowledge", label: "Job Knowledge", type: "radio" },
    { perm: "JobExpertise", field: "job_expertise", label: "Job Expertise", type: "radio" },
    { perm: "ApproachToProblem", field: "approach_to_problem", label: "Approach to Problem", type: "radio" },

    { perm: "JobAchievements", field: "job_achievements", label: "Job Related Achievements", type: "text" },
    { perm: "ReasonForReaving", field: "reason_for_leaving", label: "Reason for Leaving Job", type: "text" },

    { perm: "PersonalStrength", field: "strength", label: "Strength", type: "text" },
    { perm: "PersonalWeakness", field: "weakness", label: "Weakness", type: "text" },

    { perm: "Remarks", field: "remarks", label: "Remarks", type: "text" },
    { perm: "InterviewBy", field: "interview_by", label: "Interviewed By", type: "text" },
    { perm: "InterviewDate", field: "interview_date", label: "Interview Date", type: "date" },
    { perm: "JoiningDate", field: "pre_joining_date", label: "Pre Joining Date", type: "date" },
  ];



  const validateJobRelatedData = () => {
    const errors = [];

    REQUIRED_FIELDS.forEach(({ perm, field, label, type }) => {
      // 🔐 permission check
      if (!canView(perm)) return;

      const value = formData[field];

      if (type === "radio") {
        if (!Array.isArray(value) || value.length === 0) {
          errors.push(label);
        }
      } else {
        if (!value || value.toString().trim() === "") {
          errors.push(label);
        }
      }
    });

    setRequiredErrors(errors);
    return errors.length === 0;
  };



  const storedPerms = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch {
      return [];
    }
  }, []);

  const permSet = useMemo(() => {
    const perms = ctxPerms.length ? ctxPerms : storedPerms;
    return new Set(perms.map((p) => (typeof p === "string" ? p : p.name)));
  }, [ctxPerms, storedPerms]);

  const canSection = permSet.has("UserProfile.JobRelatedData");
  const canView = (key) => permSet.has(`UserProfile.JobRelatedData.${key}`);

  const [formData, setFormData] = useState({ ...value });
  const [saveLoading, setSaveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [shortlistLoading, setShortlistLoading] = useState(false);

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "success",
  });

  const companyOptions = [
    { label: "Quantish Opinion", value: "quantish" },
    { label: "Intellectech Solutions", value: "intellectech" },
    { label: "Intuitivetech Solutions", value: "intuitivetech" },
    { label: "InsightVerity Research PVT LTD", value: "insightverity" },
  ];

  const [selectedCompany, setSelectedCompany] = useState("quantish");

  useEffect(() => {
    const { joining_date, ...rest } = value; // ❌ remove old field
    setFormData(rest);
  }, [value]);

  const handleRadioChange = (fieldName) => (event) => {
    const value = event.target.value;
    const updatedData = {
      ...formData,
      [fieldName]: value ? [value] : [],
    };
    setFormData(updatedData);
    onChange?.(updatedData);
  };

  const handleTextChange = (field) => (event) => {
    const updatedData = { ...formData, [field]: event.target.value };
    setFormData(updatedData);
    onChange?.(updatedData);
  };

  const showConfirmationDialog = (type) => {
    const isValid = validateJobRelatedData();

    if (!isValid) {
      return; // ❌ dialog open nahi hoga
    }

    if (type === "shortlist") {
      setSelectedCompany("quantish");
      setConfirmDialog({
        open: true,
        type: "shortlist",
        title: "Confirm Shortlist",
        message:
          "Are you sure you want to shortlist this candidate? Please select the company.",
      });
    }

    if (type === "reject") {
      setConfirmDialog({
        open: true,
        type: "reject",
        title: "Confirm Rejection",
        message:
          "Are you sure you want to reject this candidate? This action cannot be undone.",
      });
    }
  };

  const handleConfirmAction = async () => {
    const { type } = confirmDialog;

    setConfirmDialog((prev) => ({ ...prev, open: false }));

    if (!value.id) {
      setSnackbar({
        open: true,
        message: "User ID is missing.",
        color: "error",
      });
      return;
    }

    const { joining_date, ...cleanFormData } = formData;

    const payload = {
      ...cleanFormData,
      status: type === "reject" ? "rejected" : "shortlisted",
      company_key: type === "shortlist" ? selectedCompany : null,
    };

    try {
      setShortlistLoading(type === "shortlist");
      setRejectLoading(type === "reject");
      const res = await onUpdate?.(payload);

      // ✅ SUCCESS (only if API success)
      setSnackbar({
        open: true,
        message:
          type === "reject"
            ? "Candidate rejected successfully"
            : "Candidate shortlisted successfully",
        color: "success",
      });
    } catch (error) {
      console.error(error);

      // ❌ API FAIL
      setSnackbar({
        open: true,
        message:
          type === "reject"
            ? "Failed to reject candidate"
            : "Failed to shortlist candidate",
        color: "error",
      });
    } finally {
      setShortlistLoading(false);
      setRejectLoading(false);
    }
  };


  const handleCancelAction = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  const renderOptions = (title, fieldName, options) => (
    <SoftBox mb={3}>
      <SoftTypography variant="caption" fontWeight="bold" className="mb-2">
        {title}
      </SoftTypography>

      <RadioGroup
        row
        value={(formData[fieldName] ?? [])[0] || ""}
        onChange={handleRadioChange(fieldName)}
      >
        <div className="row">
          {options.map((opt) => (
            <div className="col-md-6" key={opt}>
              <FormControlLabel
                value={opt}
                control={<Radio size="small" />}
                label={opt}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px", // 👈 font chhota
                    fontWeight: 500,
                  },
                }}
              />
            </div>
          ))}
        </div>
      </RadioGroup>
    </SoftBox>
  );

  if (!canSection) {
    return null;
  }

  return (
    <Card className="p-4">
      <SoftBox mb={3}>
        <SoftTypography variant="h5" className="mb-3">
          Job Related Data
        </SoftTypography>

        {/* Job Responsibilities */}
        <div className="container">
          {canView("JobResponsibility") && (
            <>
              {renderOptions("1. Present Job Responsibility", "job_responsibility", [
                "Fully Relevant",
                "Partially Relevant",
                "Allied Area",
                "Not Relevant",
              ])}
            </>
          )}
          {canView("JobKnowledge") && (
            <>
              {renderOptions("2. Job Knowledge", "job_knowledge", [
                "Very Good",
                "Good",
                "Just Sufficient",
                "Not Sufficient",
              ])}
            </>
          )}
          {canView("JobExpertise") && (
            <>
              {renderOptions("3. Job Expertise", "job_expertise", [
                "Very Good",
                "Good",
                "Above Average",
                "Acceptable",
                "Below Average",
              ])}
            </>
          )}
          {canView("ApproachToProblem") && (
            <>
              {renderOptions("4. Approach to Problem", "approach_to_problem", [
                "Logical",
                "Balanced",
                "Confused",
              ])}
            </>
          )}

          {/* Text Fields */}
          {canView("JobAchievements") && (
            <div className="row mb-4">
              <div className="col-12">
                <SoftTypography variant="caption" fontWeight="bold">
                  5. Job Related Achievements
                </SoftTypography>
                <SoftInput
                  placeholder="Your achievements"
                  value={formData.job_achievements || ""}
                  onChange={handleTextChange("job_achievements")}
                />
              </div>
            </div>
          )}

          {canView("ReasonForReaving") && (
            <div className="row mb-4">
              <div className="col-12">
                <SoftTypography variant="caption" fontWeight="bold">
                  6. Reason for leaving present job
                </SoftTypography>
                <SoftInput
                  placeholder="Write your reason"
                  value={formData.reason_for_leaving || ""}
                  onChange={handleTextChange("reason_for_leaving")}
                />
              </div>
            </div>
          )}
          {canView("PersonalStrength") && (
            <>
              <SoftTypography variant="caption" fontWeight="bold" className="mt-4 mb-2">
                Personal Traits
              </SoftTypography>

              {renderOptions("1. Personality", "personality", [
                "Impressive",
                "Smart",
                "Good",
                "Average",
                "Not Good",
              ])}
              {renderOptions("2. Leadership", "leadership", [
                "Very Good",
                "Good",
                "Average",
                "Poor",
                "Not Good",
              ])}
              {renderOptions("3. Initiative", "initiative", [
                "Self Motivated",
                "Needs Prompting",
                "Lacks Initiative",
                "Impulsive",
              ])}
              {renderOptions("4. Mannerism", "mannerism", [
                "Pleasant",
                "Acceptable",
                "Do not know etiquette",
              ])}
            </>
          )}

          {/* Strength & Weakness */}
          {canView("PersonalWeakness") && (
            <div className="row mb-4">
              <div className="col-12 col-md-6">
                <SoftTypography variant="caption" fontWeight="bold">
                  His/Her Strength
                </SoftTypography>
                <SoftInput
                  placeholder="Write your Strength"
                  value={formData.strength || ""}
                  onChange={handleTextChange("strength")}
                />
              </div>
              <div className="col-12 col-md-6">
                <SoftTypography variant="caption" fontWeight="bold">
                  His/Her Weakness
                </SoftTypography>
                <SoftInput
                  placeholder="Write your Weakness"
                  value={formData.weakness || ""}
                  onChange={handleTextChange("weakness")}
                />
              </div>
            </div>
          )}

          {/* Other Fields */}
          <div className="row mb-4">
            {canView("Remarks") && (
              <div className="col-md-4 mb-3">
                <FormField
                  label="Remarks"
                  placeholder="Write your Remarks"
                  value={formData.remarks || ""}
                  onChange={handleTextChange("remarks")}
                />
              </div>
            )}
            {canView("InterviewBy") && (
              <div className="col-md-4 mb-3">
                <FormField
                  label="Interviewed By"
                  placeholder="Interviewer Name"
                  value={formData.interview_by || ""}
                  onChange={handleTextChange("interview_by")}
                />
              </div>
            )}
            {canView("InterviewDate") && (
              <div className="col-md-4 mb-3">
                <FormField
                  label="Interview Date"
                  type="date"
                  placeholder="Interview Date"
                  value={formData.interview_date || ""}
                  onChange={handleTextChange("interview_date")}
                />
              </div>
            )}
            {/* {canView("JoiningDate") && (
              <div className="col-md-4 mb-3">
                <FormField
                  label="Joining Date"
                  type="date"
                  placeholder="Joining Date"
                  value={formData.joining_date || ""}
                  onChange={handleTextChange("joining_date")}
                />
              </div>
            )} */}

            {canView("JoiningDate") && (
              <div className="col-md-4 mb-3">
                <FormField
                  label="Pre Joining Date"
                  type="date"
                  placeholder="pre_joining_date"
                  value={formData.pre_joining_date || ""}
                  onChange={handleTextChange("pre_joining_date")}
                  inputProps={{
                    min: formData.interview_date || undefined,
                  }}
                />
              </div>
            )}
          </div>


          {requiredErrors.length > 0 && (
            <div
              style={{
                background: "#fff4f4",
                border: "1px solid #f5c2c7",
                color: "#842029",
                padding: "10px 14px",
                borderRadius: "6px",
                marginBottom: "12px",
                fontSize: "13px",
              }}
            >
              <strong>Please fill the following required fields:</strong>
              <ul style={{ margin: "6px 0 0 18px" }}>
                {requiredErrors.map((field, index) => (
                  <li key={index}>{field}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Buttons */}
          <div className="d-flex justify-content-end gap-3">
            {canView("ShortListed") && (
              <SoftButton
                disabled={shortlistLoading || !value.is_jobrelateddata}
                variant="gradient"
                color="info"
                onClick={() => showConfirmationDialog("shortlist")}
              >
                {shortlistLoading
                  ? "Shortlisting..."
                  : value.status == "shortlisted"
                    ? "Shortlisted"
                    : "Shortlist"}
              </SoftButton>
            )}
            {canView("Reject") && (
              <SoftButton
                disabled={rejectLoading || !value.is_jobrelateddata}
                variant="gradient"
                color="error"
                onClick={() => showConfirmationDialog("reject")}

              >
                {rejectLoading ? "Rejecting..." : "Reject"}
              </SoftButton>
            )}
          </div>
        </div>

        {/* Confirmation Dialog */}
        <Dialog
          open={confirmDialog.open}
          onClose={handleCancelAction}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
        >
          <DialogTitle id="confirmation-dialog-title">{confirmDialog.title}</DialogTitle>

          <DialogContent>
            <DialogContentText id="confirmation-dialog-description">
              {confirmDialog.message}
            </DialogContentText>

            {/* ✅ SHOW DROPDOWN ONLY FOR SHORTLIST */}
            {confirmDialog.type === "shortlist" && (
              <SoftBox mt={3}>
                <SoftTypography variant="caption" fontWeight="bold" mb={1}>
                  Select Company
                </SoftTypography>

                <select
                  className="form-control"
                  value={selectedCompany}
                  onChange={(e) => setSelectedCompany(e.target.value)}
                >
                  {companyOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </SoftBox>
            )}
          </DialogContent>



          <DialogActions>
            <SoftButton onClick={handleCancelAction} color="secondary" variant="outlined">
              Cancel
            </SoftButton>

            <SoftButton
              onClick={handleConfirmAction}
              color={confirmDialog.type === "reject" ? "error" : "info"}
              variant="gradient"
              autoFocus
            >
              Confirm {confirmDialog.type === "reject" ? "Reject" : "Shortlist"}
            </SoftButton>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <SoftSnackbar
          color={snackbar.color}
          icon="notifications"
          title="Notification"
          content={snackbar.message}
          open={snackbar.open}
          close={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          time={3000}
        />
      </SoftBox>
    </Card>
  );
}

JobRelatedDataForm.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
};

export default JobRelatedDataForm;
